(function () {
  'use strict';

  // What happens after a successful add to cart, driven by the theme setting
  // "Open cart drawer on add to cart" (settings.open_drawer_on_add), which
  // layout/theme.liquid emits as window.MSM_ATC_OPEN_DRAWER:
  //
  //   true  (default) -> open the cart drawer in place
  //   false           -> go to the "Added to cart" page, as the theme did before
  //
  // Both modes run through the same interception, which is what makes them cover
  // every add path: the product page adds via jQuery (XMLHttpRequest) while
  // collection / carousel / drawer adds use fetch(), so both are wrapped. Repeat
  // adds of an item already in the cart go through /cart/change.js rather than
  // /cart/add.js, so that is matched too.
  //
  // Buy Now / dynamic checkout buttons use Shopify's own payment flow and do not
  // hit /cart/add, but a click suppressor guards against them either way - we
  // must never interrupt a checkout the shopper has already started.

  var PAGE_URL = window.MSM_ATC_PAGE_URL || '/pages/added-to-cart';
  var STORAGE_KEY = 'msm-atc-item';

  function drawerMode() {
    // Default to the drawer when the flag is absent (e.g. a cached layout).
    return window.MSM_ATC_OPEN_DRAWER !== false;
  }

  var suppress = false;
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.shopify-payment-button, [data-shopify="payment-button"], [name="checkout"], [data-buy-now], [data-product-buy-now]')) {
      suppress = true;
      setTimeout(function () { suppress = false; }, 4000);
    }
  }, true);

  function isCartWriteUrl(url) {
    if (!url) return false;
    return /\/cart\/(add|change)(\.js)?(\?|$)/.test(String(url).split('#')[0]);
  }

  function isPost(method) {
    return String(method || 'GET').toUpperCase() === 'POST';
  }

  // /cart/add.js returns either a single item object or { items: [...] };
  // /cart/change.js returns the whole cart.
  function pickItem(data) {
    if (!data) return null;
    if (data.items && data.items.length) return data.items[0];
    if (data.id) return data;
    return null;
  }

  function onAddedPage() {
    var here = window.location.pathname.replace(/\/$/, '');
    var target = String(PAGE_URL).split('?')[0].replace(/\/$/, '');
    return here === target;
  }

  function drawerIsOpen() {
    return document.documentElement.classList.contains('cart-drawer-open');
  }

  // Returns true when it handled the add (opened the drawer, or started a
  // navigation). Callers use that to skip any competing UI of their own.
  function handle(item) {
    if (suppress) return false;

    // The "Added to cart" page reads this when it loads; harmless otherwise.
    if (item) {
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(item)); } catch (e) {}
    }

    if (drawerMode()) {
      if (typeof window.openCartDrawer !== 'function') return false;
      // product-card-buttons.js and category-carousel.js also call
      // openCartDrawer after their own adds; whichever runs first wins, so the
      // drawer is never opened (and re-fetched) twice for one add.
      if (drawerIsOpen()) return true;
      try { window.openCartDrawer(); } catch (err) { return false; }
      return true;
    }

    if (!item) return false;
    // Re-open the page on EVERY add. When already on it (adding from its
    // recommendation rows) reload so it opens fresh with the just-added product
    // as the confirmation card and updated totals.
    if (onAddedPage()) {
      window.location.reload();
    } else {
      window.location.href = PAGE_URL;
    }
    return true;
  }

  window.MSM_onAddToCart = handle;
  // Legacy name: product-card-buttons.js and category-carousel.js call this
  // after adds that go through /cart/change.js, which the interceptors below
  // also catch. Kept so those files need no change; it now routes to whichever
  // mode is configured rather than always navigating.
  window.MSM_goToAddedPage = handle;

  // --- fetch ---
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url);
      var method = (init && init.method) || (input && input.method);
      var p = origFetch.apply(this, arguments);
      if (isCartWriteUrl(url) && isPost(method)) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(function (data) { handle(pickItem(data)); }).catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  }

  // --- XMLHttpRequest (jQuery on the product page) ---
  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var open = XHR.prototype.open;
    var send = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      this.__atcMethod = method;
      this.__atcUrl = url;
      return open.apply(this, arguments);
    };
    XHR.prototype.send = function () {
      var xhr = this;
      if (isCartWriteUrl(xhr.__atcUrl) && isPost(xhr.__atcMethod)) {
        xhr.addEventListener('load', function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          var data;
          try { data = JSON.parse(xhr.responseText); } catch (e) { return; }
          handle(pickItem(data));
        });
      }
      return send.apply(this, arguments);
    };
  }
})();
